import { useState, useContext } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Text, Flex } from '@chakra-ui/react';
import { CbButton, CbInput } from 'ui/components';
import { AppContext } from 'providers';
import arcadeApiClient from 'apiClients/arcadeApiClient';
interface VerifyEmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  onEmailVerified: () => void;
}
export const VerifyEmailModal = ({
  isOpen,
  onClose,
  email,
  onEmailVerified
}: VerifyEmailModalProps) => {
  const [verificationCode, setVerificationCode] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const {
    setToast
  } = useContext(AppContext);
  const handleSubmit = () => {
    setIsSubmitting(true);
    setError(null);
    arcadeApiClient.put('/multi_platform/users/verify_email', {
      verification_code: verificationCode
    }).then(() => {
      setToast({
        status: 'success',
        description: 'Email verified successfully!'
      });
      onClose();
      onEmailVerified();
    }).catch(() => {
      setError('Invalid verification code. Please try again.');
    }).finally(() => {
      setIsSubmitting(false);
    });
  };
  return <Modal isOpen={isOpen} onClose={onClose} isCentered data-sentry-element="Modal" data-sentry-component="VerifyEmailModal" data-sentry-source-file="VerifyEmailModal.tsx">
      <ModalOverlay data-sentry-element="ModalOverlay" data-sentry-source-file="VerifyEmailModal.tsx" />
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="VerifyEmailModal.tsx">
        <ModalCloseButton variant="cb-ghost" data-sentry-element="ModalCloseButton" data-sentry-source-file="VerifyEmailModal.tsx" />
        <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="VerifyEmailModal.tsx">Verify Email</ModalHeader>
        <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="VerifyEmailModal.tsx">
          <Text mb={4} data-sentry-element="Text" data-sentry-source-file="VerifyEmailModal.tsx">
            We have just sent a code to {email}. Make sure to check your spam
            folder.
          </Text>
          <CbInput value={verificationCode} onChange={e => {
          setVerificationCode(e.target.value);
          setError(null);
        }} placeholder="Enter verification code" mb={2} isInvalid={!!error} data-sentry-element="CbInput" data-sentry-source-file="VerifyEmailModal.tsx" />
          {error && <Text color="red.500" fontSize="sm" mb={4}>
              {error}
            </Text>}
          <Flex justify="flex-end" gap={4} mb={6} data-sentry-element="Flex" data-sentry-source-file="VerifyEmailModal.tsx">
            <CbButton width="100%" onClick={handleSubmit} isLoading={isSubmitting} isDisabled={!verificationCode || verificationCode.length !== 6} data-sentry-element="CbButton" data-sentry-source-file="VerifyEmailModal.tsx">
              Submit
            </CbButton>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>;
};